import httpContext from 'express-http-context';
import get from 'idx';
import { isUndefined } from 'lodash';
import { normalizeOptimalprintQueries } from './browserLocation';

const globalFn = (key: string) => {
  // check 'cookie' from server state (httpContext.cookie)
  if (key !== 'cookie') {
    const fromCookie = getGlobalCookie(key);

    if (!isUndefined(fromCookie)) {
      return fromCookie;
    }
  }

  // check query and then global variable store
  if (typeof window !== 'undefined') {
    const urlQueries = normalizeOptimalprintQueries(window.location.search);

    if (!isUndefined(urlQueries[key])) {
      return urlQueries[key];
    }

    return get((window as any), _ => _.OP.CategoryProduct[key]);
  }

  return httpContext.get(key);
};

export const parseCookies = (cookie: string) => {
  const pairs = cookie.split(';');
  return pairs.reduce((acc, pair) => {
    const split = pair.split('=');
    const key = split[0].trim();
    const value = unescape(split[1]);
    return {
      ...acc,
      [key]: value,
    };
  }, {} as { [s: string]: string });
};

export const getGlobalCookie = (key: string) => {
  const cookiesRaw = parseCookies(globalFn('cookie') || '');
  const cookies = normalizeOptimalprintQueries(cookiesRaw);
  return cookies[key];
};

export default globalFn;
